module.exports = __webpack_public_path__ + "img/GP1-visa_she_s_next-2.f278fec0.png";